/* eslint-disable react/button-has-type */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { useEffect, useState, useRef } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import EditIcon from '@mui/icons-material/Edit';
import BlockIcon from '@mui/icons-material/Block';
import lottie from 'lottie-web';
import SnackBar from '../../../components/snackbar/snackbar';

import Page from '../../../components/Page';
import ClientInfo from './clientDetailsTabs/ClientInfo';
import User from './clientDetailsTabs/User';
import Subscription from './clientDetailsTabs/Subscription';
import Modal from '../../../components/modal/Index';
import AddClientForm from '../users/AddClientForm';
import adminServices from '../../../services/adminServices';
import lottieData from '../../../assets/lottie/lottie-loading.json';
import Billing from './clientDetailsTabs/Billing';
import AuditHistory from './clientDetailsTabs/Audithistory';
import UsersAndRoles from './clientDetailsTabs/UsersRoles';
import PlansTab from './clientDetailsTabs/PlansTab';


function TabPanel({ children, value, index }) {
  return (
    <div hidden={value !== index}>
      {value === index && (
        <div className="py-6">
          {children}
        </div>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number,
  value: PropTypes.number,
};

export default function ClientDetails() {
  const location = useLocation();
  const lottoLoad = useRef();
  const { from } = location.state || {};

  const [value, setValue] = useState(0);
  const [clientDetails, setClientDetails] = useState({});
  const [data, setData] = useState([]);
  const [learnerCount, setLearnerCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [subscriptionData, setSubscriptionData] = useState([]);
  const [lottieLoading, setLottieLoading] = useState(true);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [mode, setMode] = useState('');
  const [clientId, setClientId] = useState(null);
  const [isActive, setIsActive] = useState(true);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarTitle, setSnackbarTitle] = useState('');
  const PAGE_SIZE = 10;
  const [userPage, setUserPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [adminUsers, setAdminUsers] = useState([]);
  const [deactivating, setDeactivating] = useState(false);


  const handleChange = (index) => {
    setValue(index);
    if (index === 3) {
      setUserPage(0);
      getUserLists(0);
    }
  };

  const getClientInformation = async () => {
    try {
      const response = await adminServices.getClientInfo(from);
      if (response.ok) {
        setClientDetails(response.data);
        setIsActive(response.data.status === 'ACTIVE');
      }
      setLottieLoading(false);
    } catch (e) {
      console.log(e);
      setLottieLoading(false);
    }
  };

  const getAdminUsers = async () => {
    try {
      const response = clientDetails?.slug
        ? await adminServices.getTenentUsers(from, 0, 100, `tenant_${clientDetails.slug}`)
        : await adminServices.getusers(from, 0, 100);
      if (response.ok) {
        const users = response.data?.users || response.data?.data || response.data || [];
        setAdminUsers(users.filter((u) => u.role !== 'AUTH_USER'));
      }
    } catch (e) { console.log(e); }
  };

  const getUserLists = async (page = 0) => {
    setLoading(true);
    try {
      const schema = clientDetails?.slug ? `tenant_${clientDetails.slug}` : null;
      const response = await adminServices.getlearners(from, page, PAGE_SIZE, schema, 'AUTH_USER');
      if (response.ok) {
        setData(response.data.users || []);
        setLearnerCount(response.data.total || 0);
        setTotal(response.data.total || 0);
      }
      setLoading(false);
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const getSubscription = async () => {
    try {
      const response = await adminServices.getSubscriptionData(from);
      if (response.ok) setSubscriptionData(response.data);
    } catch (e) {
      console.log(e);
    }
  };

  const handleEditFromOverview = () => {
    setMode('edit');
    setClientId(clientDetails?.id);
    setModalOpen(true);
  };

  // Org-level deactivation only — no scope
  const handleDeactivate = async (reason) => {
    const newStatus = isActive ? 'INACTIVE' : 'ACTIVE';
    setDeactivating(true);
    try {
      const result = await adminServices.handleClientStatus(from, {
        status: newStatus,
        reason: reason || '',
      });
      if (result.ok) {
        setIsActive((prev) => !prev);
        setOpenSnackbar(true);
        setSnackbarTitle(result.data.message);
        getClientInformation();
        getAdminUsers();
      } else {
        setOpenSnackbar(true);
        setSnackbarTitle(result.data?.message);
      }
    } catch (error) {
      console.log(error);
      setOpenSnackbar(true);
      setSnackbarTitle('Failed to update client status.');
    } finally {
      setDeactivating(false);
    }
  };

  useEffect(() => {
    if (from) {
      getClientInformation();
      setLoading(true);
      getSubscription();
    }
  }, [from]);

useEffect(() => {
  if (clientDetails?.id) {
    getAdminUsers();
  }
}, [clientDetails, from]);

  useEffect(() => {
    if (lottoLoad.current) {
      lottie.loadAnimation({
        container: lottoLoad.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: lottieData,
      });
    }
  }, []);

  const Breadcrumb = () => (
    <div className="text-sm mb-4 flex items-center gap-2">
      <span className="text-gray-500">Super Admin</span>
      <span className="text-gray-400">›</span>
      <RouterLink to="/app/client-users" className="text-gray-500 hover:text-gray-700">
        Client Admins
      </RouterLink>
      <span className="text-gray-400">›</span>
      <span className="text-gray-900 font-medium">
        {clientDetails.organizationName || 'Client Details'}
      </span>
    </div>
  );

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const date = new Date(dateStr);
    if (Number.isNaN(date.getTime())) return '-';
    const formatCode = clientDetails?.dateFormat?.code || 'MM/DD/YYYY';
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = String(date.getFullYear());
    switch (formatCode.toUpperCase()) {
      case 'DD/MM/YYYY': return `${dd}/${mm}/${yyyy}`;
      case 'MM/DD/YYYY': return `${mm}/${dd}/${yyyy}`;
      case 'YYYY/MM/DD': return `${yyyy}/${mm}/${dd}`;
      case 'YYYY-MM-DD': return `${yyyy}-${mm}-${dd}`;
      case 'DD-MM-YYYY': return `${dd}-${mm}-${yyyy}`;
      case 'MM-DD-YYYY': return `${mm}-${dd}-${yyyy}`;
      case 'DD.MM.YYYY': return `${dd}.${mm}.${yyyy}`;
      default: return `${mm}/${dd}/${yyyy}`;
    }
  };

  return (
    <Page title={clientDetails.organizationName || 'Client Details'}>
      <div className="p-6">
        <Breadcrumb />

        {lottieLoading ? (
          <div
            ref={lottoLoad}
            className="w-12 mx-auto py-10"
          />
        ) : (
          <>
            {/* Header */}
            <div className="flex justify-between items-start mb-6">
              <div className="flex flex-col gap-2">
                <div className="flex items-center gap-3">
                  <h1 className="text-xl font-semibold text-gray-900">
                    {clientDetails?.organizationName}
                  </h1>

                  <span className="text-xs font-medium px-2 py-1 rounded bg-blue-100 text-blue-600">
                    {clientDetails?.featureToggleMode || 'B2B'}
                  </span>

                  <span
                    className={`text-xs font-medium px-2 py-1 rounded ${isActive
                      ? 'bg-green-100 text-green-600'
                      : 'bg-gray-100 text-gray-500'
                      }`}
                  >
                    {isActive ? 'Active' : 'Inactive'}
                  </span>
                </div>
              </div>
            </div>

            {/* Tabs */}
            <div className="border-b border-gray-200">
              <div className="flex gap-4">
                {[
                  'Overview',
                  'Plans',
                  'Users & Roles',
                  'Learners',
                  'Contract',
                  'Audit History',
                ].map((tab, index) => (
                  <button
                    key={tab}
                    onClick={() => handleChange(index)}
                    className={`px-4 py-3 text-sm font-medium border-b-2 ${value === index
                      ? 'border-blue-600 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700'
                      }`}
                  >
                    {tab}
                  </button>
                ))}
              </div>
            </div>

            {/* Panels */}
            {/* 0 — Overview */}
            <TabPanel value={value} index={0}>
              <ClientInfo
                clientDetails={clientDetails}
                onEdit={handleEditFromOverview}
                learnerCount={learnerCount}
                formatDate={formatDate}
                isActive={isActive}
                onDeactivate={handleDeactivate}
                deactivating={deactivating}/>
            </TabPanel>

            {/* 1 — Plans */}
            <TabPanel value={value} index={1}>
              <PlansTab clientDetails={clientDetails} />
            </TabPanel>

            {/* 2 — Users & Roles */}
            <TabPanel value={value} index={2}>
              <UsersAndRoles
                clientDetails={clientDetails}
                userList={adminUsers}
                refreshUsers={getAdminUsers}
                refreshClient={getClientInformation}
              />
            </TabPanel>

            {/* 3 — Learners */}
            <TabPanel value={value} index={3}>
              <User
                data={data}
                getUserLists={getUserLists}
                clientDetails={clientDetails}
                page={userPage}
                loading={loading}
                pageSize={PAGE_SIZE}
                total={total || 0}
                onPageChange={(p) => {
                  setUserPage(p);
                  getUserLists(p);
                }}
              />
            </TabPanel>

            {/* 4 — Contract */}
            <TabPanel value={value} index={4}>
              <Billing clientDetails={clientDetails} />
            </TabPanel>

            {/* 5 — Audit History */}
            <TabPanel value={value} index={5}>
              <AuditHistory clientDetails={clientDetails} />
            </TabPanel>
          </>
        )}
        {/* RIGHT DRAWER */}
        <Modal
          title={mode === 'create' ? 'Create Client Admin' : 'Edit Client Admin'}
          open={modalOpen}
          toggle={() => setModalOpen(false)}
        >
          <AddClientForm
            mode={mode}
            clientDetails={clientDetails}
            clientId={clientId}
            getClientList={getClientInformation}
            toggle={() => setModalOpen(false)}
            snackBarControl={() => { }}
          />
        </Modal>
        <SnackBar open={openSnackbar} snackbarTitle={snackbarTitle} close={() => setOpenSnackbar(false)} />
      </div>
    </Page>
  );
}
